import type { ComponentProps } from "react";

import { tw } from "@/shared/utils";

const Root = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={tw(
      "flex flex-col gap-4 rounded-2xl border border-secondary-100 p-4 text-neutral-950",
      className,
    )}
    {...props}
  />
);

const Banner = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={tw(
      "relative z-10 flex h-32 items-center justify-center overflow-hidden rounded-lg bg-primary-100",
      className,
    )}
    {...props}
  />
);

const Content = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={tw(
      "flex grow flex-col items-center gap-2 text-center",
      className,
    )}
    {...props}
  />
);

const Title = ({ className, children, ...props }: ComponentProps<"h3">) => (
  <h3 className={tw("text-xl font-medium", className)} {...props}>
    {children}
  </h3>
);

const Description = ({ className, ...props }: ComponentProps<"p">) => (
  <p className={tw("font-medium", className)} {...props} />
);

const Actions = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    className={tw(
      "flex w-full flex-col-reverse items-center gap-2 *:w-full *:flex-1 xl:flex-row",
      className,
    )}
    {...props}
  />
);

export const DocumentCard = {
  Root,
  Banner,
  Content,
  Title,
  Description,
  Actions,
};
